import React from "react";
import Axios from "axios";
import TagManager from 'react-gtm-module';
import ReactPixel from 'react-facebook-pixel';
 
const storeContext = React.createContext();
export const Consumer = storeContext.Consumer;

export class Provider extends React.Component {
	constructor(props) {
		super(props); 
		let restType = this.getRestType(props.router.match.path);
		let route = props.router.match.path;
		let slug = props.router.match.params.slug ? props.router.match.params.slug : '';
		let term = props.router.match.params.term ? props.router.match.params.term : '';
		let catid = props.router.match.params.catid ? props.router.match.params.catid : ''; 
		let timer = null;
		let user = false;
		this.state = {
			user: {
				checked: 				false,
				auth_token: 			false,
				id:						false,
				street_address: 		false,
				city: 					false,
				phone: 					false,
				state: 					false,
				postcode: 				false,
				ship_street_address: 	false,
				ship_city: 				false,
				ship_state: 			false,
				ship_postcode: 			false,
				company: 				false,
				abn: 					false,
				pricing: 				'all',	
				cart: {
					count: 0,
					items: false,
				}
			},
			lampshades: {
				open: 				[],
				shape: 				null,
				size: 				null,
				fittingtype: 		null,
				fittingdimension: 	null,
				washersize: 		null,
				fabric: 			null,
				specialtrim: 		null,
				specialtrimlocation:null,
				valid: 				true
			},
			scrollPos:0,
			lastScrollPos:0,
			lastlastScrollPos:0,
			orderNotes:'',
			openOrders: [],
			term: term,
			slug: slug,
			restType: restType,
			lastRestType: null,
			catid: catid,
			route: route,
			posts: [], 
			filterMenu: null,
			filters: {
				designer: [],
				product_cat: [],
				finish: [],
			},
			filterOpen: null,
			menu: {
				mobileOpen: false,
				mobilePanel: -1,
				json: null,
				currentPanel: -1,
				animateIn: true,
				animateOut: true,
				interactive: true,
				menuFetched:false,
			},
			tracking: {
				json: null,
				trackingFetched: false,
				initialLoad: false,
				facebook: false
			},
			searchOpen:false,
			siteLoaded: false,
			pageLoaded: false,
			currentPage: 1, 
			totalPages: 0,      
			appError : '',
			frmMsg: '',
			doRender:false,
			loginOpen: this.checkInitLoginState(props.router.location.hash),
			passwordResetStep:this.checkInitResetState(props.router.location.hash),
			cartOpen:false,
			cartStep:0,
			toggleMobMenu: this.toggleMobMenu.bind(this),
			toggleSearch: this.toggleSearch.bind(this),
			getMenu: this.getMenu.bind(this),
			getTracking: this.getTracking.bind(this),
			setMobilePanel: this.setMobilePanel.bind(this),
			setMenuState: this.setMenuState.bind(this),
			checkLoggedIn: this.checkLoggedIn.bind(this),
			toggleLogin: this.toggleLogin.bind(this),
			togglePasswordReset: this.togglePasswordReset.bind(this),
			toggleCart: this.toggleCart.bind(this),
			cartPrev: this.cartPrev.bind(this),
			cartNext: this.cartNext.bind(this),
			submitLogin: this.submitLogin.bind(this),
			submitPasswordReset: this.submitPasswordReset.bind(this),
			submitOrder: this.submitOrder.bind(this),
			submitSearch: this.submitSearch.bind(this),
			editCart: this.editCart.bind(this),
			updateLampshades: this.updateLampshades.bind(this),
			changeFilters: this.changeFilters.bind(this),
			changeFilterMenu: this.changeFilterMenu.bind(this),
			changeOpenOrder: this.changeOpenOrder.bind(this),
			updateOrderNote: this.updateOrderNote.bind(this),
			updateScrollPos: this.updateScrollPos.bind(this),
			logout: this.logout.bind(this),
			decodeHTMLEntities: this.decodeHTMLEntities.bind(this)
		};
	}
	
	updateScrollPos() {
		this.setState({scrollPos: window.scrollY});
	}
	
	checkInitLoginState(hash){
		if (hash === '#login' || hash === '#reset-password') {
			return true;
		} else {
			return false;
		}
	}
	
	checkInitResetState(hash){
		if (hash === '#reset-password') {
			return 0;
		} else {
			return -1;
		}
	}
	
	updateOrderNote(orderNotes) {
		this.setState({orderNotes: orderNotes});
	}
	
	updateLampshades(lampshades) {
		this.setState({lampshades: lampshades});
	}
	
	changeFilters(filters) {
		this.setState({filters: filters});
	}
	
	changeFilterMenu(menu) {
		this.setState({filterMenu: menu});
	}
	
	changeOpenOrder(order) {
		let openOrders = this.state.openOrders;
		let index = openOrders.indexOf(order);
		if (index !== -1) {
			openOrders.splice(index, 1);
		} else {
			openOrders.push(order);
		}
		this.setState({openOrders: openOrders});
	}
	
	/* user.version controls updates - make an update and change version number to sign uses out automatically */
	
	checkLoggedIn(_buildUrl) {
	
		const value = localStorage.getItem("user"); // synchronous
	
		let user = this.state.user;
	
		try {
			const data = JSON.parse(value);
	
			if (data) {
				if (data.id === null || data.id === 'false' || data.id === false || data.id === undefined) {
					user.id = false;
					user.cart.count = 0;
					user.cart.items = false;
				} else {
					user = data;
				}
			}
		} catch (error) {
			user.id = false;
			user.cart = { count: 0, items: false };
		}
	
		this.setState({ user });
	
		if (_buildUrl === true) {
			this.getPosts(this.buildUrl());
		}
	}
	
	submitOrder(user, first_name, last_name, phone, address, city, state, postcode, deliveryNotes, orderNotes) {
		
		let postdata = new FormData();
		
		if (first_name) {
			postdata.append('first_name', first_name);
		} else {
			postdata.append('first_name', user.first_name);
		}
		
		if (last_name) {
			postdata.append('last_name', last_name);
		} else {
			postdata.append('last_name', user.last_name);
		}
		
		if (phone) {
			postdata.append('phone', phone);
		} else {
			postdata.append('phone', user.phone);
		}
		
		if (address) {
			postdata.append('address_1', address);
		} else if (user.ship_street_address) {
			postdata.append('address_1', user.ship_street_address);
		} else {
			postdata.append('address_1', user.street_address);
		}
		
		if (city) {
			postdata.append('city', city);
		} else if (user.ship_city) {
			postdata.append('city', user.ship_city);
		} else {
			postdata.append('city', user.city);
		}
		
		if (state) {
			postdata.append('state', state);
		} else if (user.ship_city) {
			postdata.append('state', user.ship_state);
		} else {
			postdata.append('state', user.state);
		}
		
		if (postcode) {
			postdata.append('postcode', postcode);
		} else if (user.ship_postcode) {
			postdata.append('postcode', user.ship_postcode);
		} else {
			postdata.append('postcode', user.postcode);
		}
		
		console.log('state order notes: ', this.state.orderNotes);
		
		postdata.append('ordernotes', this.state.orderNotes);
		postdata.append('deliverynotes', deliveryNotes);
		
		let _i = 0;
		let _productString = '';
		let _qtyString = '';
		for (_i=0;_i<user.cart.items.length;_i++) {
			_productString 	= _productString + user.cart.items[_i].id + '-';
			_qtyString 		= _qtyString + user.cart.items[_i].qty + '-';
		}
		
		postdata.append('products', _productString.slice(0, -1));
		postdata.append('qtys', _qtyString.slice(0, -1));
		
		postdata.append('id',user.id);
		postdata.append('auth_token',user.auth_token);
		
		let _url = window.location.origin + '/wp-content/themes/bloomingdales/functions/create-order.php';
		
		fetch(_url, {
			method: 'POST',
			body: postdata,
			})
		.then((response) => response.json())
		.then((responseJson) => {
			if (responseJson.passed === true) {
				user = this.state.user;
				user.cart.count = 0;
				user.cart.items = false;
				this.setState({
					user: user,
					cartStep : 2,
					orderNotes: ''
				});
				localStorage.setItem('user', JSON.stringify(user));	
			} else {
				user = this.state.user;
				user.id = false;
				user.auth_token = false;
				this.setState({
					user: user,
					cartOpen:false,
					cartStep:0,
					loginOpen: true
				});
			}
		})
		.catch((error) => {
			//console.log(error);
		});
	}

	submitLogin(email, password) {
		
		let user = this.state.user;
		
		if (email !== false && password !== false && email !== '' && password !== '') {
			let _url = window.location.origin + '/wp-content/themes/bloomingdales/functions/authenticate.php';
			
			let postdata = new FormData();
			postdata.append('type', 'login');
			postdata.append('email', email);
			postdata.append('password', password);
			
			fetch(_url, {
				method: 'POST',
				body: postdata,
  			})
			.then((response) => response.json())
			.then((responseJson) => {
				let data = responseJson.data;
				
				if (!data.user_id) {
					user = [];
					user.cart = [];
				}
																
				if (!data.user_id || !user) {
															
					user.id = -1;
					user.cart.count = 0;
					user.cart.items = null;
			
					this.setState({
						user: user,
						frmMsg: responseJson.msg,
						loginOpen: true
					});
					
				} else {
																												
					user.id 					= data.user_id;
					user.auth_token 			= data.auth_token;
					user.first_name 			= data.first_name;
					user.last_name				= data.last_name;
					user.street_address 		= data.street_address;
					user.city 					= data.city;
					user.state 					= data.state;
					user.postcode 				= data.postcode;
					user.ship_street_address 	= data.ship_street_address;
					user.ship_city 				= data.ship_city;
					user.ship_state 			= data.ship_state;
					user.ship_postcode 			= data.ship_postcode;
					user.company 				= data.company;
					user.abn 					= data.abn;
					user.pricing 				= data.pricing;
										
					user.cart.count = 0;
					user.cart.items = false;
										
					this.setState({
						user: user,
						frmMsg: responseJson.msg,
						loginOpen: false
					});
					localStorage.setItem('user', JSON.stringify(user));
					
				}
			})
		} else if (email === false || email === '') {
			user.id = -1;
			user.cart.count = 0;
			user.cart.items = null;
			this.setState({
				user: user,
				loginOpen: true,
				frmMsg: 'Please enter your email address'
			});
		} else if (password === false || password === '') {
			user.id = -1;
			user.cart.count = 0;
			user.cart.items = null;
			this.setState({
				user: user,
				loginOpen: true,
				frmMsg: 'Please enter your password'
			});
		}
	}
	
	submitPasswordReset(step, email, code, password) {
		if (step === 0 || step === 1 | step === 2) {
			if (email) {
				
				let _url = window.location.origin + '/wp-content/themes/bloomingdales/functions/authenticate.php';
				
				let postdata = new FormData();
				postdata.append('type', 'reset-step-' + (step + 1));
				postdata.append('email', email);
				
				if (step === 0 || (step === 1 && code) || (step === 2 && password)) {
					
					postdata.append('code', code);
					postdata.append('password', password);
					
					fetch(_url, {
						method: 'POST',
						body: postdata,
		  			})
					.then((response) => response.json())
					.then((responseJson) => {
						let data = responseJson;
												
						if (data.success === 'false' || data.success === false) {
							
							this.setState({
								frmMsg: data.msg,
								passwordResetStep: step
							});
						
						} else {

							if (step === 2) {	
								
								let user = this.state.user;
								
								user.id 					= data.user_id;
								user.auth_token 			= data.auth_token;
								user.first_name 			= data.first_name;
								user.last_name				= data.last_name;
								user.street_address 		= data.street_address;
								user.city 					= data.city;
								user.state 					= data.state;
								user.postcode 				= data.postcode;
								user.ship_street_address 	= data.ship_street_address;
								user.ship_city 				= data.ship_city;
								user.ship_state 			= data.ship_state;
								user.ship_postcode 			= data.ship_postcode;
								user.company 				= data.company;
								user.abn 					= data.abn;
								
								user.cart.count = 0;
								user.cart.items = false;
											
								this.setState({
									user: user,
									frmMsg: data.msg,
									passwordResetStep: 0,
									loginOpen: false
								});
								localStorage.setItem('user', JSON.stringify(user));
								
							} else {
								this.setState({
									frmMsg: data.msg,
									passwordResetStep: (step + 1)
								});
							}
						}
							
					})
					.catch((error) => {
						this.setState({						
							frmMsg: 'An error occurred! Please try again.'
						});
					});
				} else if (step === 1) {
					this.setState({
						frmMsg: 'Please enter a new password'
					});
				} else if (step === 1) {
					this.setState({
						frmMsg: 'Please enter your verification code'
					});
				}
			} else if (!email) {
				this.setState({
					frmMsg: 'Please enter your email address'
				});
			}
		}		
	}
	
	editCart(product, qty, add) {
		
		let userID = this.state.user.id;
		
		if (!qty) {
			let qty = 0;
		}
				
		if (product) {
						
			let user 	= this.state.user;
			let items 	= user.cart.items;
			let found 	= false;
			let count 	= 0;
			let pItems 	= [];
			
			if (items.length < 1) {
				items = false;
			}
						
			if (items) {
				for (let i=0;i<items.length;i++) {
					if (items[i].id === product.id) {
						if (qty === 0) {
							items[i].qty = 0;
						} else {
							if (add === true) {
								items[i].qty += qty;
							} else {
								items[i].qty = qty;
							}
						}
						items[i].id 		= product.id;
						items[i].slug 		= product.slug;
						items[i].heading 	= product.heading;
						items[i].color 		= product.color;
						items[i].price 		= product.price;
						items[i].srcset 	= product.srcset;
						items[i].src 		= product.src;
						found = true;
					}
				}
				if (found === false && qty > 0) {
					let index = parseInt(items.length);
					items[index] = [];
					items[index].id 		= product.id;
					items[index].qty 		= qty;
					items[index].slug 		= product.slug;
					items[index].heading 	= product.heading;
					items[index].color 		= product.color;
					items[index].price 		= product.price;
					items[index].srcset 	= product.srcset;
					items[index].src 		= product.src;
				}
				
				for (let j=0;j<items.length;j++) {
					if (items[j].qty > 0) {
						let item = {
							"id" 		: items[j].id,
							"qty" 		: items[j].qty,
							"heading" 	: items[j].heading,
							"slug" 		: items[j].slug,
							"color" 	: items[j].color,
							"srcset" 	: items[j].srcset,
							"src" 		: items[j].src,
							"price" 	: items[j].price,
						}
						count = count + items[j].qty;
						pItems.push(item);
					} 	
				}
			} else if (qty > 0) {
				let item = {
					"id" 		: product.id,
					"qty" 		: qty,
					"heading" 	: product.heading,
					"slug" 		: product.slug,
					"color" 	: product.color,
					"srcset" 	: product.srcset,
					"src" 		: product.src,
					"price" 	: product.price,
				}
				count = qty;
				pItems.push(item);
			}			
			
			user.cart.count = count;
			user.cart.items = pItems;				
			this.setState({
				user: user,
			});
			localStorage.setItem('user', JSON.stringify(user));			
		}
	}
	
	cartNext(){
		let _step = this.state.cartStep + 1;
		this.setState({cartStep: _step});
	}
	cartPrev(){
		let _step = this.state.cartStep - 1;
		this.setState({cartStep: _step});
	}
	
	toggleCart(){
		if (this.state.cartOpen === true) {
			this.setState({cartOpen: false});
			setTimeout(() => this.setState({
				cartStep : 0,
			}), 800);
		} else {
			this.setState({cartOpen: true});
			
		}
	}
	
	submitSearch(term) {   
		this.setState({
			restType : 'search',  
		});
		this.props.router.history.push('/search/' + term);
	}
	
	toggleLogin(){
		if (this.state.loginOpen === true) {
			this.setState({loginOpen: false});
		} else {
			this.setState({loginOpen: true});
		}
	}
	
	togglePasswordReset(){
		if (this.state.passwordResetStep === -1) {
			this.setState({passwordResetStep: 0});
		} else {
			this.setState({passwordResetStep: -1});
		}
	}
	
	logout(){
		let user = this.state.user;
		user.id = -1;
		user.cart.count = 0;
		user.cart.items = null;
		this.setState({user: user});
		localStorage.setItem('user', JSON.stringify(user));
	}
	
	getMenu(url) {
		let self = this;
		let menu = this.state.menu;
		if (menu.json === null && menu.menuFetched === false) {
			menu.menuFetched = true;
			self.setState({
				menu : menu
			});
			Axios.get(url).then((response)=>{
				menu.json = response.data[0];
				self.setState({
					menu : menu
				});
				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));
				}, 100);
			}); 
		}
	}
	
	getTracking(url) {
		let self = this;
		let tracking = this.state.tracking;
		if (tracking.json === null && tracking.trackingFetched === false) {
			tracking.trackingFetched = true;
			self.setState({
				tracking : tracking
			});
			Axios.get(window.location.origin + '/wp-json/bloomingdales/v1/tracking').then((response)=>{
				tracking.json = response.data[0];
				let i = 0;
				let fbInit = false;
				for (let i=0;i<tracking.json.length;i++) {
					if (tracking.json[i].type == 'gtag') {
						let tagManagerArgs = {
						    gtmId: tracking.json[i].id
						}
						TagManager.initialize(tagManagerArgs)
					} else if (tracking.json[i].type == 'fb') {
						ReactPixel.init(tracking.json[i].id);
						fbInit = true;
					}
				}
				if (fbInit === true) {
					ReactPixel.pageView();
					tracking.facebook = true;
				}
				self.setState({
					tracking : tracking
				});
			}); 
		}
	}
	
	toggleMobMenu() {
		let menu = this.state.menu;
		if (menu.mobileOpen === false) {
			menu.mobileOpen = true;
		} else {
			menu.mobileOpen = false;
			setTimeout(
				function() {
					this.setMobilePanel(-1);
				}
				.bind(this),
				500
			);
		}
		this.setState({menu: menu});
	}
	
	
	
	toggleSearch() {
		let searchOpen = this.state.searchOpen;
		if (searchOpen === false) {
			searchOpen = true;
		} else {
			searchOpen = false;
		}
		this.setState({searchOpen : searchOpen});
	}
	
	setMobilePanel(index) {
		let menu = this.state.menu;
		menu.mobilePanel = index;
		this.setState({menu});
	}
	
	setMenuState(currentPanel,animateIn,animateOut) {
		let menu 			= this.state.menu;
		menu.currentPanel 	= currentPanel;
		menu.animateIn 		= animateIn;
		menu.animateOut 	= animateOut;
		
		this.setState({menu});
	}
	
	getColor (path) {
		let color = null;
		if (path == '/product/:slug/:color') {
			color = this.props.router.match.params.color;
		}
		
		return color;
	}

	
	getRestType (path){
		let restType = '';
		switch(path){   
			case '/':
				restType = 'front';
				break;  
			case '/lampshades-made-to-measure/':
				restType = 'lampshades';
				break;
			case '/news/':
				restType = 'news-archive';
				break;  
			case '/customer-registration/':
				restType = 'customer-registration';
				break;  
			case '/account/':
				restType = 'account';
				break;  
			case '/account/details/':
				restType = 'details';
				break; 
			case '/account/quote-requests/':
				restType = 'requests';
				break; 
			case '/news-category/:slug':
				restType = 'news-category';
				break;
			case '/collection/:slug':
				restType = 'collection';
				break;
			case '/product-category/:slug':
				restType = 'product-category';
				break;
			case '/designer/:slug':
				restType = 'designer';
				break;
			case '/search/:slug':
				restType = 'search';
				break;
			case '/product/:slug/:color':
				restType = 'product';
				break;
			case '/product/:slug':
				restType = 'product';
				break;
			case '/news/:slug':
				restType = 'news';
				break;
			case '/search/:term':
				restType = 'search';
				break;
			case '/category/:catid':
				restType = 'category';
				break;
			case '/:slug':
				restType = 'page';
				break;
			case '/post/:slug':
			default:
				restType = 'post';
			break;
		}
		return restType;
	}

	componentDidMount(){ 
		if (this.state.restType === 'account' || this.state.restType === 'details' || this.state.restType === 'requests' || this.state.restType === 'product') {
			this.checkLoggedIn(true);  
		} else {
			this.checkLoggedIn(true);  
			this.getPosts(this.buildUrl());  
		}
		    
	}

	componentDidUpdate(prevProps){ 
		if(prevProps.router.location.pathname !== this.props.router.location.pathname || prevProps.router.location.search !== this.props.router.location.search){  
			let curProps = this.props.router.match;  
			let lastScrollPos = this.state.scrollPos;
			let lastlastScrollPos = this.state.lastScrollPos;
			this.setState({
				lastScrollPos: lastScrollPos,
				lastlastScrollPos: lastlastScrollPos,
				scrollPos: 0,
				currentPage : 1, 
				lastRestType: this.state.restType,
				restType : this.getRestType(curProps.path), 
				slug: this.props.router.match.params.slug ? this.props.router.match.params.slug : '',
				color : this.props.router.match.params.color ? this.props.router.match.params.color : '',
				catid : curProps.params.catid ? curProps.params.catid : ''
			},function(){
				this.getPosts(this.buildUrl()); 
			})
		} 
	}

	buildUrl(){
		let url = '/wp-json/bloomingdales/v1/';  
		let sort = '';
		let stock = '';
		let hash = window.location.hash + '';
		if (hash.indexOf('#sort-by') !== -1) {
			sort = hash.replace('#', '');	
		} 
		if (hash.indexOf('#stock') !== -1) {
			stock = hash.replace('#', '');	
		}
		
		let params = (new URL(document.location)).searchParams;
		let sortParams = params.get("sort");
		
		if (sortParams) {
			if (sortParams.length > 2) {
				sort = 'sort=' + sortParams;
			} 
		}
		
		let stockParams = params.get("stock");
		if (stockParams) {
			if (stockParams.length > 2) {
				stock = 'stock=' + stockParams;
			} 
		}
		
		let user = this.state.user;
		let userID = user.id;
		if (userID === false || userID === 'false' || userID === null) {
			userID = -1;
		};
		let rand = 'v=' + Math.round(Math.random() * (999999 - 100000) + 100000);
		switch(this.state.restType){   
			case 'front': 
				url += 'front';
				break;  
			case 'news-archive': 
				url += 'news-archive';
				break;  
			case 'lampshades': 
				url += 'lampshades-made-to-measure';
				break;  
			case 'customer-registration': 
				url += 'customer-registration';
				break;  
			case 'account': 
				url += 'account?auth_token=' + this.state.user.auth_token + '&id=' + this.state.user.id;
				break;  
			case 'details': 
				url += 'account?auth_token=' + this.state.user.auth_token + '&id=' + this.state.user.id;
				break;  
			case 'requests': 
				url += 'account?auth_token=' + this.state.user.auth_token + '&id=' + this.state.user.id;
				break;  
			case 'page': 
				url += 'page/';
				url += this.state.slug
				break;
			case 'news': 
				url += 'news/';
				url += this.state.slug
				break;
			case 'news-category': 
				url += 'news-category/';
				url += this.state.slug;
				break;
			case 'product-category': 
				url += 'product-category/';
				url += this.state.slug;
				url += '?' + sort + '&' + stock + '&' + rand + '&user=' + userID;				
				break;
			case 'collection': 
				url += 'collection/';
				url += this.state.slug;
				url += '?' + sort + '&' + stock + '&' + rand + '&user=' + userID;
				break;
			case 'designer': 
				url += 'designer/';
				url += this.state.slug;
				url += '?' + sort + '&' + stock + '&' + rand + '&user=' + userID;
				break;
			case 'search': 
				url += 'search/';
				url += this.state.slug;
				url += '?' + sort + '&' + stock + '&' + rand + '&user=' + userID;
				break;
			case 'product':
				url += 'product/';
				url += this.state.slug + '?v=' + rand + '&user=' + userID;
				break;
			case 'category': 
				url += 'posts?categories=';
				url += this.state.catid;
				url += '&page=' + this.state.currentPage;
				break;      
			case 'post': 
				default:      
				url += this.state.slug ? 'posts/?slug=' + this.state.slug : 'posts/?page=' + this.state.currentPage;
				break;      
		}
		url = url.replaceAll('v=v=', 'v=');
		url = url.replaceAll('&&', '&');
		url = url.replaceAll('&&', '&');
		url = url.replaceAll('?&', '?');
		url = url.replaceAll('?user=-1', '');
		
		return url;
	}
	
	decodeHTMLEntities(str) {
		if(str && typeof str === 'string') {
			// strip script/html tags
			let element = document.createElement('div');
			str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
			str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
			element.innerHTML = str;
			str = element.textContent;
			element.textContent = '';
		}
		return str;
	}

	getPosts (url){		
		
		this.getTracking();

		let menu = this.state.menu;
		menu.mobileOpen = false;
		menu.currentPanel = -1;
		menu.animateOut = true;
		menu.interactive = false;
		if ( 
			(this.state.restType == 'account' && this.state.lastRestType == 'details') ||
			(this.state.restType == 'account' && this.state.lastRestType == 'requests') ||
			(this.state.restType == 'details' && this.state.lastRestType == 'account') ||
			(this.state.restType == 'details' && this.state.lastRestType == 'requests') ||
			(this.state.restType == 'requests' && this.state.lastRestType == 'account') ||
			(this.state.restType == 'requests' && this.state.lastRestType == 'details') ||
			(this.state.restType == 'product' && this.state.lastRestType == 'product') ||
			(this.state.restType == 'news-category' && this.state.lastRestType == 'news-category') ||
			(this.state.restType == 'news-category' && this.state.lastRestType == 'news-archive') ||
			(this.state.restType == 'news-archive' && this.state.lastRestType == 'news-category') ||
			(this.state.restType == 'news-archive' && this.state.lastRestType == 'news-archive') 
		) {
			this.setState({
				pageLoaded:true,
				menu:menu,
				searchOpen: false,
				doRender: false
			});
		} else {
			this.setState({
				pageLoaded:false,
				menu:menu,
				searchOpen: false,
				doRender: false
			});
		}
		let self = this;
		Axios.get(url).then((response)=>{
			if (JSON.stringify(response.data).length > 10) {
				let user = this.state.user;
				if (response.data.auth_token) {
					user.first_name 			= response.data.first_name;
					user.last_name				= response.data.last_name;
					user.street_address 		= response.data.street_address;
					user.city 					= response.data.city;
					user.state 					= response.data.state;
					user.postcode 				= response.data.postcode;
					user.ship_street_address 	= response.data.ship_street_address;
					user.ship_city 				= response.data.ship_city;
					user.ship_state 			= response.data.ship_state;
					user.ship_postcode 			= response.data.ship_postcode;
					user.company 				= response.data.company;
					user.abn 					= response.data.abn;
					localStorage.setItem('user', JSON.stringify(user));
				}
				let tracking = self.state.tracking;
				if (tracking.initialLoad === false) {
					tracking.initialLoad = true;
				} else {
					if (tracking.facebook === true) {
						ReactPixel.pageView();
					}
				}
				try {
					document.title = this.decodeHTMLEntities(response.data[0].title) + ' - Bloomingdales';
				} catch (error) {
					//console.error(error);
				}

				self.setState({
					user : user,
					posts : response.data, 
					filterMenu: null,
					doRender: true,
					/*
					filters: {
						designer: [],
						product_cat: [],
						finish: []
					},
					*/
					tracking: tracking,
					filterOpen: null,
					totalPages : response.headers['x-wp-totalpages']
				},function(){          
					let menu = this.state.menu;
					menu.interactive = true;
					setTimeout(() => this.setState({
						pageLoaded : true,
						siteLoaded : true,
						menu : menu
					}), 10);
					if (this.state.restType == 'collection' || this.state.restType == 'product-category' || this.state.restType == 'designer' || this.state.restType == 'search') {
						if (this.state.lastRestType == 'product') {
							window.scrollTo(0, this.state.lastlastScrollPos);
						}
					}
				});
			} else {
				window.location = 'https://www.bloomingdales.com.au/';
			}
		}).catch(function(error){
			self.appError = 'An unexpected error occurred';
		});  
	}

	render() {
    	return (
			<storeContext.Provider value={this.state}>
				{this.props.children}
			</storeContext.Provider>
		);
	}
}